function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-shading_svg__a",
  d: "M0 0h100v100H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "icon-shading_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-shading_svg__a",
  overflow: "visible"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.99 6h75.4c1.1 0 1.99.89 1.99 1.99v83.7c0 1.1-.89 1.99-1.99 1.99h-75.4c-1.1 0-1.99-.89-1.99-1.99V7.99c0-1.1.89-1.99 1.99-1.99h0zm5.95 79.71h63.49V13.97H17.94v71.74h0zm0-59.78h63.49-63.49 0zm0 11.95h63.49-63.49 0zm0 11.96h63.49-63.49 0z",
  clipPath: "url(#icon-shading_svg__b)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

function SvgIconShading(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgo8Zz4KCTxnPgoJCTxkZWZzPgoJCQk8cmVjdCBpZD0iU1ZHSURfMV8iIHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIi8+CgkJPC9kZWZzPgoJCTxjbGlwUGF0aCBpZD0iU1ZHSURfMl8iPgoJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF8xXyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPgoJCTwvY2xpcFBhdGg+CgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTExLjk5LDZoNzUuNGMxLjEsMCwxLjk5LDAuODksMS45OSwxLjk5djgzLjdjMCwxLjEtMC44OSwxLjk5LTEuOTksMS45OWgtNzUuNGMtMS4xLDAtMS45OS0wLjg5LTEuOTktMS45OQoJCQlWNy45OUMxMCw2Ljg5LDEwLjg5LDYsMTEuOTksNkwxMS45OSw2eiBNMTcuOTQsODUuNzFoNjMuNDlWMTMuOTdIMTcuOTRWODUuNzFMMTcuOTQsODUuNzF6IE0xNy45NCwyNS45M2g2My40OUgxNy45NEwxNy45NCwyNS45MwoJCQl6IE0xNy45NCwzNy44OGg2My40OUgxNy45NEwxNy45NCwzNy44OHogTTE3Ljk0LDQ5Ljg0aDYzLjQ5SDE3Ljk0TDE3Ljk0LDQ5Ljg0eiIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=";
export { SvgIconShading as ReactComponent };